import { Box, Stack, useTheme } from '@mui/material';

import { Typography, ProgressIndicator } from '@occc/ui-design-system';

type UploadedFileItemProps = {
  name: string;
  isCompleted: boolean;
  progress?: number;
  isSmallProgressIndicator?: boolean;
};

export const UploadedFileItem = ({
  name,
  isCompleted,
  progress,
  isSmallProgressIndicator = false,
}: UploadedFileItemProps) => {
  const theme = useTheme();

  return (
    <Box
      display='flex'
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      flexWrap='wrap'
    >
      <Typography variant='body1'>{name}</Typography>

      {isCompleted && (
        <Typography variant='subtitle2' component='p' color='success.main'>
          Uploaded
        </Typography>
      )}

      {!isCompleted && (
        <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
          <Typography variant='body2' color='text.secondary'>
            Uploading File
          </Typography>

          <ProgressIndicator
            current={progress ?? 0}
            total={1}
            color={theme.palette.primary.main}
            width={isSmallProgressIndicator ? 80 : undefined}
          />
        </Stack>
      )}
    </Box>
  );
};
